import { FC, ReactElement } from 'react'

import ProductCarousel from '../../components/carousel/productCarousel'
import FacultyBanner from '../../components/faculty/facultyBanner'
import FacultyDeals from '../../components/faculty/facultyDeals'
import FacultyEmail from '../../components/faculty/facultyEmail'
import FacultySchool from '../../components/faculty/facultySchool'
import Page from '../../components/page'
import { useI18n } from '../../hooks'
import { useAppSelector } from '../../store'
import { filterByPromoCategory } from '../../utils'

import './faculty.css'

const FacultyPage: FC = (): ReactElement => {
  const { products } = useAppSelector((state) => state.productReducer)
  const { promoCategories } = useAppSelector((state) => state.categoryReducer)

  const targetProducts = filterByPromoCategory(products, promoCategories, 'facultyTrending')
  const trendingProducts = targetProducts.slice(2, targetProducts.length)
  const dealsProducts = targetProducts.slice(0, 2)
  const { t } = useI18n()
  return (
    <Page
      metaData={{ title: t('Faculty_meta_title'), description: t('Faculty_meta_description'), charset: 'utf-8' }}
      className="faculty-page"
    >
      <header className="faculty-top-banner">
        <FacultyBanner />
      </header>
      {dealsProducts?.length > 0 && <FacultyDeals products={dealsProducts} />}
      {trendingProducts?.length > 0 && (
        <ProductCarousel
          products={trendingProducts}
          title={t('Categories_trendingProductsForFaculty').toUpperCase()}
          viewAllUrl="/shop?category=faculty trending"
        />
      )}
      <FacultyEmail />
      <FacultySchool />
    </Page>
  )
}

export default FacultyPage
